/*
 * Copyright (c) 2020. World Wide Generation Ltd
 */


import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import G17Client from '../services/G17Client';


const surveyAvailable = createSlice({
  name: 'surveyAvailable',
  initialState: { data: false, loading: false, loaded: false, errored: false, errorMessage: '' },
  reducers: {
    load: (state) => {
      return { ...state, loading: true, loaded: false, errored: false, errorMessage: '' };
    },
    loaded: (state, action) => {
      return { ...state, loading: false, loaded: true, data: action.payload.available, errored: false, errorMessage: '' }
    },
    error: (state, action: PayloadAction<Error>) => {
      return { ...state, loading: false, errored: true, errorMessage: action.payload.message };
    }
  }
})

export const { load, loaded, error } = surveyAvailable.actions;
export default surveyAvailable.reducer;

export const loadSurveyAvailable = () => async (dispatch: any, getState: () => any) => {
  const state = getState()[surveyAvailable.name];
  if (state.loading || state.loaded) {
    return;
  }
  dispatch(load());
  G17Client.userHasSurveys()
    .then((data) => {
      dispatch(loaded(data))
    })
    .catch((err: Error) => {
      dispatch(error(err));
    })
}
